import {
  getActiveMonth,
  getActiveYear,
} from 'app/dealer/shared/utils/pure-functions/dates';
import { DEALERS_INSIGHTS_TIME_DIVISIONS } from 'app/dealer/shared/modules/dealersInsights/api/dealersInsights.api';
import { DEALERS_INSIGHTS_LEVELS } from 'app/dealer/shared/modules/dealersInsights/redux/level/constants';

import { getListingsBenchmarkCacheDictionaryKey } from './listings/selectors';
import {
  listingsBenchmarkDataInitialState,
  topListingsBenchmarkInitialState,
  listingsTurnoverListingsBenchmarkInitialState,
  listingsImagesListingsBenchmarkInitialState,
} from './reducer.initialData';
import { getTopListingsBenchmarkCacheDictionaryKey } from './topListings/selectors';
import { getListingsTurnoverListingsBenchmarkCacheDictionaryKey } from './listingsTurnover/selectors';
import { TOP_LISTINGS_CATEGORIES } from './topListings/constants';
import { getListingsImagesListingsBenchmarkCacheDictionaryKey } from './listingsImages/selectors';

/**
 * @typedef {'month'|'year'} TimeDivision
 */

/**
 *
 * @typedef {Object} ListingsBenchmarkState
 * @property {any[]} errors
 * @property {TimeDivision} selectedTimeDivisionFilter
 * @property {TimeDivision} previouslySelectedTimeDivision - persists this value between auth sessions when token expires, allowing the UI to keep this filter
 * @property {Date} previouslySelectedDate - allows session date picker to persist when user token expires and refreshes
 * @property {string} selectedMonth - month (non JS) sent to the api e.g. December = 12
 * @property {number} selectedYear
 * @property {Date} selectedDate
 * @property {number} selectedTopListingsCount
 * @property {boolean} listingTileCountupDisabled
 * @property {'byFavourites'|'byViews'|'byLeads'} selectedTopListingsCategory
 * @property {Object<string, import('./reducer.initialData').ListingsBenchmarkResponse>} - cache data by date
 * @property {Object<string, import('./reducer.initialData').ListingsBenchmarkTopListingsResponse>} - cache top listings data by date
 */

/**
 * @param {Object} [options]
 * @returns {ListingsBenchmarkState}
 */
export const defaultState = (options = {}) => {
  const date = options.testDate || new Date();
  if (!options.testMonth) {
    date.setDate(0);
  }
  const selectedMonth = options.testMonth || getActiveMonth(date);
  const selectedYear = options.testYear || getActiveYear(date);
  const selectedTimeDivisionFilter = DEALERS_INSIGHTS_TIME_DIVISIONS.MONTH;
  const cacheKeyData = [
    selectedTimeDivisionFilter,
    selectedYear,
    selectedMonth,
    DEALERS_INSIGHTS_LEVELS.NETWORK,
  ];
  return {
    errors: [],
    selectedTimeDivisionFilter,
    previouslySelectedTimeDivision: selectedTimeDivisionFilter,
    previouslySelectedDate: date,
    selectedYear,
    selectedMonth,
    selectedDate: date,
    listingTileCountupDisabled: false,
    [getListingsBenchmarkCacheDictionaryKey(
      ...cacheKeyData,
    )]: listingsBenchmarkDataInitialState,
    [getTopListingsBenchmarkCacheDictionaryKey(
      ...cacheKeyData,
    )]: topListingsBenchmarkInitialState,
    selectedTopListingsCount: 3,
    selectedTopListingsCategory: TOP_LISTINGS_CATEGORIES.byLeads,
    [getListingsTurnoverListingsBenchmarkCacheDictionaryKey(
      ...cacheKeyData,
    )]: listingsTurnoverListingsBenchmarkInitialState,
    [getListingsImagesListingsBenchmarkCacheDictionaryKey(
      ...cacheKeyData,
    )]: listingsImagesListingsBenchmarkInitialState,
  };
};
